import React from 'react';
import { StyleSheet } from 'react-native';
import { Image } from 'react-native';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

export const UserAvatar = ({ size = 104, avatarUrl }: { size?: number; avatarUrl?: string }) => {
    return (
        <Box
            style={styles.avatarContainer}
            overflow="hidden"
            width={size}
            height={size}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderRadius="r96"
            borderWidth={1}
            padding="s10"
        >
            {avatarUrl ? <Image style={styles.avatar} height={size - 20} width={size - 20} src={avatarUrl} /> : null}
        </Box>
    );
};

const styles = StyleSheet.create({
    avatarContainer: {
        borderColor: ds.colorValue.border.subtle,
    },
    avatar: {
        borderRadius: 100,
    },
});
